import {render, h} from 'preact'
import $ from '@modules/jquery-import';
import {jqueryValidate} from '@modules/lazy-imports';
import {paymentServiceUnavailable, paymentServiceUnavailableTAM} from '@util/HtmlComponents';
import PaymetricIframe from '@ultradent/upi-paymetric-iframe';
import TokenService from '@services/TokenService';
import User from '@modules/User';
import AddressBook from './components/account/AddressBook';


// note ->
$( function () {

    let $validator;
    const profileForm = $( '#accountProfileForm' );

    jqueryValidate().then( () => {
        $validator = profileForm.validate( {
            messages: {
                billingAddress: 'Please add or select a billing address from the list'
            }
        } );
    } );

    $( document ).on( 'field:validate-if-needed', function ( e, field ) {
        if ( field && !!field.value ) {
            $validator && $validator.element( field );
        }
    }.bind( this ) );

    var cardTypeSelector = document.getElementById( 'CardType' );
    if ( cardTypeSelector != null ) {
        initCreditCardForm( cardTypeSelector )
    }

    const addressBookContainer = document.getElementById( 'addressBook' );
    if ( addressBookContainer != null ) {
        initAddressBook( addressBookContainer, ( address, fieldId ) => {
            console.log( 'Received address change:', address );
            if ( fieldId ) {
                const billingField = document.getElementById( fieldId );
                setTimeout( () => $validator.element( billingField ), 0 )
            }
        } );
    }
} );

const initCreditCardForm = async ( selector ) => {
    const Module = await import(/*webpackChunkName: "~~credit-card-display"*/ './modules/forms/credit-card-display');
    const creditCardDisplay = Module.default;

    creditCardDisplay( selector );

    let paymetricForm;

    const paymetricPlaceholder = $( '#paymetric-cc-container' )[0];
    if ( paymetricPlaceholder ) {
        TokenService.getPaymetricAccessToken()
            .then( tokenInfo => {
                paymetricForm = new PaymetricIframe( tokenInfo );
                return paymetricForm.loadIframe( {} );
            } )
            .catch( err => {
                console.error( '[PaymetricError]', err );
                // fixme -> TAM lock out should be moved to server view
                // if ( User.isTamProxy() ) {
                //     return $( '#morePaymentOptions' ).append( paymentServiceUnavailableTAM );
                // }

                $( '#morePaymentOptions' ).append( paymentServiceUnavailable );
            } );
    }

};

const initAddressBook = async ( container, onAddressChange ) => {
    const userAddresses = await User.Address.getAddressBook();
    const defaultAddress = User.Address.getSuggestedBillingAddress( userAddresses );
    const addressBook = (
        <AddressBook
            groupId="billingAddress"
            addresses={userAddresses}
            defaultAddress={defaultAddress}
            allowAddItem={true}
            onAddressChange={onAddressChange}/>
    );

    render( addressBook, null, container );
};